const tblSingle = {
  55: [25.90,29.30,32.60,37.00],
  56: [26.90,30.40,33.70,38.10],
  57: [27.90,31.50,34.80,39.20],
  58: [28.90,32.60,35.90,40.30],
  59: [29.30,33.70,37.00,41.40],
  60: [30.40,34.80,38.10,43.50],
  61: [31.50,35.90,39.20,43.60],
  62: [32.60,37.00,40.30,44.70],
  63: [33.70,38.10,41.40,46.30],
  64: [34.80,39.20,43.50,47.40],
  65: [35.90,40.30,43.60,48.50],
  66: [37.00,41.40,44.70,49.60],
  67: [38.10,43.50,46.30,50.00],
  68: [39.20,43.60,47.40,50.80],
  69: [40.30,44.70,48.50,51.90],
  70: [41.40,46.30,49.60,53.00],
  71: [43.50,47.40,50.00,53.50],
  72: [43.60,48.50,50.80,54.40],
  73: [44.70,49.60,51.90,54.40],
  74: [46.30,50.00,53.00,54.40],
  75: [47.40,50.80,53.50,54.40],
  76: [48.50,51.90,54.40,54.40],
  77: [49.60,53.00,54.40,54.40],
  78: [50.00,53.50,54.40,54.40],
  79: [50.80,54.40,54.40,54.40],
  80: [51.90,54.40,54.40,54.40],
  81: [53.00,54.40,54.40,54.40],
  82: [53.50,54.40,54.40,54.40],
  83: [54.40,54.40,54.40,54.40],
  84: [54.40,54.40,54.40,54.40],
  85: [54.40,54.40,54.40,54.40],
  86: [54.40,54.40,54.40,54.40],
  87: [54.40,54.40,54.40,54.40],
  88: [54.40,54.40,54.40,54.40],
  89: [54.40,54.40,54.40,54.40],
  90: [54.40,54.40,54.40,54.40]
};

const tblJoint = {
  55: [undefined,29.30,32.60,37.00],
  56: [25.10,30.40,33.70,38.10],
  57: [26.10,31.50,34.80,39.20],
  58: [27.10,32.60,35.90,40.30],
  59: [28.00,33.70,37.00,41.40],
  60: [29.30,34.80,38.10,43.50],
  61: [30.40,35.90,39.20,43.60],
  62: [31.50,37.00,40.30,44.70],
  63: [32.60,38.10,41.40,46.30],
  64: [33.70,39.20,43.50,47.40],
  65: [34.80,40.30,43.60,48.50],
  66: [35.90,41.40,44.70,49.60],
  67: [37.00,43.50,46.30,50.00],
  68: [38.10,43.60,47.40,50.80],
  69: [39.20,44.70,48.50,51.90],
  70: [40.30,46.30,49.60,53.00],
  71: [41.40,47.40,50.00,53.50],
  72: [43.50,48.50,50.80,54.40],
  73: [43.60,49.60,51.90,54.40],
  74: [44.70,50.00,53.00,54.40],
  75: [46.30,50.80,53.50,54.40],
  76: [47.40,51.90,54.40,54.40],
  77: [48.50,53.00,54.40,54.40],
  78: [49.60,53.50,54.40,54.40],
  79: [50.00,54.40,54.40,54.40],
  80: [50.80,54.40,54.40,54.40],
  81: [51.90,54.40,54.40,54.40],
  82: [53.00,54.40,54.40,54.40],
  83: [53.50,54.40,54.40,54.40],
  84: [54.40,54.40,54.40,54.40],
  85: [54.40,54.40,54.40,54.40],
  86: [54.40,54.40,54.40,54.40],
  87: [54.40,54.40,54.40,54.40],
  88: [54.40,54.40,54.40,54.40],
  89: [54.40,54.40,54.40,54.40],
  90: [54.40,54.40,54.40,54.40],
};

// const isValid = x => (typeof x !== 'undefined' && x !== null && !isNaN(x));

export const getLtvValue = ({ clientAge, isJoint, housePrice, ltvPlan }) => {
  const age = (clientAge > 90) ? 90 : clientAge;
  const tbl = (isJoint) ? tblJoint[age] : tblSingle[age];
  const Healthy = parseInt( housePrice * 0.01 * tbl[0], 10);
  const Mild = parseInt( housePrice * 0.01 * tbl[1], 10);
  const Moderate = parseInt( housePrice * 0.01 * tbl[2], 10);
  const Severe = parseInt( housePrice * 0.01 * tbl[3], 10);

  const result = { Healthy, Mild, Moderate, Severe };
  result.max = result[ ltvPlan || 'Severe' ];
  result.diff = result.Severe - result.Healthy;
  result.pct = { Healthy: tbl[0], Mild: tbl[1], Moderate: tbl[2], Severe: tbl[3] };
  console.log('ltvPlan=', ltvPlan, result)
  return result;
};



// WEBPACK FOOTER //
// ./src/services/LtvCalc.js